export enum CanvasType {
  ACRYLIC,
  ACRYLICANDOILSTICK,
  CHALKCOLOR,
  CHALKCOLORANDGRAPHITE,
  CHALKCOLORANDPASTELL,
}
